import React from "react";
import {connect} from "react-redux";
import {faRoute} from "@fortawesome/pro-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {mapHeaderDispatchToProps} from "./Container";
import {FullSizeIconWithText} from "../../Core/LoadingAnimation";
import {faShieldAlt} from "@fortawesome/pro-solid-svg-icons/faShieldAlt";

function Error404(props) {
    React.useEffect(() => {
        props.setHeader('753 - Access restricted.', <FontAwesomeIcon icon={faRoute}/>)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <>
        <FullSizeIconWithText icon={<FontAwesomeIcon icon={faShieldAlt} size={"3x"}/>}
                              text={<h1>Access restricted.</h1>}/>
    </>;
}

const mapStateToProps = () => {
    return {}
};

const Container404 = connect(
    mapStateToProps,
    mapHeaderDispatchToProps,
)(Error404);

export {Error404};
export default Container404;